module.exports = __webpack_public_path__ + "static/Unbounded-Bold-455a78fad3315cbee5d23a6186664991.woff2";